import { accommodationTypeIdZodSchema } from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-type-id";
import { capacityZodObject } from "@@/shared/acquire/resources/resource-accommodation/capacity";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { iconNameZodString } from "@@/shared/icon-name";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const accommodationTypeAddCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("ACCOMMODATION_TYPE_ADD_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    accommodationTypeId: accommodationTypeIdZodSchema,
    title: requiredTranslatableZodSchema,
    iconName: iconNameZodString.optional(),
    shortDescription: translatableZodSchema.optional(),
    providerId: providerIdZodSchema.optional(),
    capacity: capacityZodObject,
});

type AccommodationTypeAddCommand = z.infer<
    typeof accommodationTypeAddCommandZodObject
>;

const accommodationTypeAddCommandFactoryParamsZodObject =
    accommodationTypeAddCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof accommodationTypeAddCommandFactoryParamsZodObject
>;

const accommodationTypeAddCommandFactory = (params: FactoryParams) => {
    const accommodationTypeAddCommand: AccommodationTypeAddCommand = {
        ...params,
        _id: generateId({ prefix: "accommodation_type_add_command__" }),
        _type: "ACCOMMODATION_TYPE_ADD_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return accommodationTypeAddCommand;
};

export {
    accommodationTypeAddCommandFactory,
    accommodationTypeAddCommandFactoryParamsZodObject,
    accommodationTypeAddCommandZodObject,
};
export type {
    AccommodationTypeAddCommand,
    FactoryParams as AccommodationTypeAddCommandFactoryParams,
};
